<script>
	import { superadmin } from "./stores/store.js";

import {push, pop, replace} from 'svelte-spa-router'
import { postData, isJson, mergeDeep } from './scripts';
import { autentificado, prefix, urlapi, login, iduser,user, miPermiso, permisos_struct,sucursal, sucursalStore } from "./stores/store";

let osucursal='0';

//let username='christianlp';
//let password='db1515so';
let username='';
let password='';
let result = null;
let datos = null;
let enviando = false;
let error = false;

localStorage.clear();

$: contentButton = valor =>(
    valor ? '<div class="spinner-border spinner-border-sm text-dark" role="status"></div> Verificando...':'Entrar'
)

function SendLogin () {
    enviando=true;
    $login = false;
    $iduser = false;
    $user = false;
    $sucursal = false;
    
    $miPermiso = {};

    postData($urlapi, [{ 'usuario':username, 'password':password, 'sucursal':osucursal, 'cmd':'login_verificar' }])
    .then(data => {

          localStorage.clear();
          enviando=false;

          if(data[0].result===false) {
              error=true;
          } else {
            
            if(isJson( data[0].result.permisos)===true) {
                $miPermiso=mergeDeep($permisos_struct, JSON.parse(data[0].result.permisos));
            } else {
                $miPermiso=$permisos_struct;
            }

            if (osucursal==9999) {
                $superadmin=true;
                $sucursal = Object.keys($sucursalStore)[0];
            } else {
                $superadmin=false;
                $sucursal = osucursal;
            }
                     
            //$miPermiso=$permisos_struct;
            
            if($miPermiso.general.access===false) {
              error=true;
            } else {
              localStorage.setItem($prefix+'_token',data[0].result.token);
              $login = true;
              $iduser = data[0].result.iduser;
              $user = data[0].result.username;
              push('/');
            }

          }
    });

}

/*
                if(isJson( data[0].result.permisos)===true) {
                    mispermisos=JSON.parse(data[0].result.permisos);
                } else {
                    mispermisos=$permisos_struct;                    
                }
*/
postData($urlapi, [{ 'cmd':'sucursales_listAll' }])
.then(data => {
    $sucursalStore={}
    Object.values(data[0].result).map(function(value) {
      $sucursalStore={...$sucursalStore,[value.id] :value.nombre}
    });
    
});

async function postData2(url = '', data = {}) {
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(data)
  });
  
  return response.json()
  //return JSON.parse(response.json());  
}

</script>

<!-- svelte-ignore a11y-invalid-attribute -->
<div class="container h-100">
  <div class="d-flex justify-content-center h-100">
    <div class="user_card">
      <div class="d-flex justify-content-center">
        <div class="brand_logo_container">
          <img
            src="images/logo-scanapp.png"
            class="brand_logo"
            alt="Logo"
          />
        </div>
      </div>
      <div class="d-flex justify-content-center form_container">
        <form on:submit|preventDefault={SendLogin}>
          <div class="input-group mb-2">
            <div class="input-group-append">
              <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
            </div>
            <input
              type="text"
              class="form-control input_user"
              bind:value={username}
              placeholder="username"
              disabled={enviando}
            />
          </div>
          <div class="input-group mb-2">
            <div class="input-group-append">
              <span class="input-group-text"><i class="bi bi-key-fill"></i></span>
            </div>
            <input
              type="password"
              name=""
              class="form-control input_pass"
              bind:value={password}
              placeholder="password"
              disabled={enviando}
            />
          </div>

          <div class="input-group mb-2">
            <div class="input-group-append">
              <span class="input-group-text"><i class="bi bi-shop"></i></span>
            </div>
            <select class="form-select" disabled={enviando} bind:value={osucursal}>
              <option value='0'>Seleccione Sucursal</option>
              {#each Object.keys($sucursalStore) as item}
                  <option value='{String(item)}'>{$sucursalStore[item]}</option>
              {/each}
              <option value='9999'>Todas</option>              
            </select>            

          </div>

          <div class="d-flex justify-content-center mt-3 login_container">
            <button type="submit" name="button" class="btn login_btn" disabled={enviando}>{@html contentButton(enviando)}</button>
          </div>
        </form>
      </div>

      {#if error}
        <div style='background:rgba(255,255,255,0.2)' class="alert text-white fw-bold text-center border-2 border-danger p-1 mt-3 mb-0" role="alert">
          <i class="bi bi-exclamation-circle-fill me-1"></i>Error de acceso
        </div>
      {/if}
      

    </div>
  </div>
</div>

<style>
  .user_card {
    height: 400px;
    width: 350px;
    margin-top: auto;
    margin-bottom: auto;
    background: #001b70;
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
      0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
      0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius: 5px;
  }
  .brand_logo_container {
    position: absolute;
    height: 170px;
    width: 170px;
    top: -75px;
    border-radius: 50%;
    background: #fff;
    padding: 10px;
    text-align: center;
  }
  .brand_logo {
    height: 150px;
    width: 150px;
    border-radius: 50%;
    border: 2px solid white;
  }
  .form_container {
    margin-top: 70px;
  }
  .login_btn {
    width: 100%;
    background: #bb0722 !important;
    color: white !important;
  }
  .login_btn:focus {
    box-shadow: none !important;
    outline: 0px !important;
  }
  .login_container {
    padding: 0 2rem;
  }
  .input-group-text {
    background: #bb0722 !important;
    color: white !important;
    border-color:#bb0722;
    border-radius: 0.25rem 0 0 0.25rem !important;
  }
  input, select
  {
    box-shadow: none !important;
    outline: 0px !important;
  }

</style>
